import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import useRecaptcha from '@/hooks/useRecaptcha.util.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { AxiosError, HttpStatusCode } from 'axios';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

type Props = {
  error: AxiosError | null;
  isCaptchaActive: boolean;
  isProcessing: boolean;
  onSubmit: (e: React.FormEvent, captchaToken?: string) => void;
  setIsCaptchaActive: Dispatch<SetStateAction<boolean>>;
};

export const WelcomeCaptcha: React.FC<Props> = props => {
  const { error, isCaptchaActive, isProcessing, onSubmit, setIsCaptchaActive } = props;
  const { captchaToken, handleRecaptcha, recaptchaRef } = useRecaptcha();
  const { t } = useTranslationWithPrefix('welcomePage');
  const isMobile = useMobileMediaQuery();

  useEffect(() => {
    if (error && error.response?.status === HttpStatusCode.Forbidden) {
      setIsCaptchaActive(true);
    }
  }, [error, setIsCaptchaActive]);

  if (!isCaptchaActive && (!error || error.response?.status !== HttpStatusCode.Forbidden)) {
    return null;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(e, captchaToken);
  };

  return (
    <>
      <div className="fixed inset-0 bg-white/50 backdrop-blur-[15px] z-50 h-[200%]" />
      <div
        style={{
          backgroundColor: 'white',
          left: '50%',
          padding: '20px',
          position: 'fixed',
          top: '50%',
          transform: `translate(-50%, ${isMobile ? '+100%' : '-100%'})`,
          zIndex: 100,
        }}
      >
        <form onSubmit={handleSubmit}>
          <ReCAPTCHA
            onChange={handleRecaptcha}
            ref={recaptchaRef}
            sitekey="6LctgNYqAAAAABJZfayTGvU1s9nBZXBt_7CGX1Wx"
          />
          <ButtonWithLoading
            className="w-full mt-2"
            disabled={!captchaToken || isProcessing}
            type="submit"
          >
            {t('buttons.submit')}
          </ButtonWithLoading>
        </form>
      </div>
    </>
  );
};
